import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Cpu, Brain, User } from "lucide-react";

function RegisterOption() {
  const [selectedOption, setSelectedOption] = useState(null);
  const navigate = useNavigate();
  const options = [
    {
      id: "university",
      title: "University",
      icon: Cpu,
      link: ''
    },
    {
      id: "industry",
      title: "Industry",
      icon: Brain,
      link: ''
    },
    {
      id: "independent_researcher",
      title: "Independent Researcher",
      icon: User,
      link: ''
    },
  ];

  const handleContinue = () => {
    if (!selectedOption) return;
    
    if(selectedOption === 'independent_researcher') {
      navigate(`/marketplace/${selectedOption}`);
    } else if(selectedOption === 'university') {
      navigate(`/marketplace/${selectedOption}`);
    } else if(selectedOption === 'industry') {
      navigate(`/marketplace/${selectedOption}`);
    }
  };

  return (
    <div className="mt-12 flex items-center justify-center px-4">
      <div className="max-w-lg w-full bg-white rounded-2xl shadow-lg p-8">
        {/* Header */}
        <div className="text-center mb-2">
          <div className="mb-4 flex flex-col sm:flex-row sm:items-center gap-4 px-4 sm:px-0">
  {/* Icon */}
  <div className="w-16 h-16 bg-[#e8f0f7] rounded-full flex items-center justify-center mx-auto sm:mx-0 mb-2 sm:mb-0">
    <svg
      className="w-8 h-8 text-[#0f6abf]"
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M18 9v3m0 0v3m0-3h3m-3 0h-3m-2-5a4 4 0 11-8 0 4 4 0 018 0zM3 20a6 6 0 0112 0v1H3v-1z"
      />
    </svg>
  </div>

  {/* Title */}
  <h2 className="text-xl sm:text-2xl font-bold text-gray-900 text-center sm:text-left">
    AxionNest MarketPlace
  </h2>
</div>

          <p className="text-gray-600">
            Select how you want to join AxionNest MarketPlace
          </p>
        </div>

        {/* Options */}
        <div className="space-y-4 mb-8">
          {options.map((option) => {
            const Icon = option.icon;
            const isActive = selectedOption === option.id;

            return (
              <button
                key={option.id}
                onClick={() => setSelectedOption(option.id)}
                className={`w-full flex items-center gap-4 p-4 rounded-xl border transition-all duration-200
                  ${
                    isActive
                      ? "border-[#0f6abf] bg-[#e8f0f7]"
                      : "border-gray-200 hover:border-gray-300 hover:bg-gray-50"
                  }
                `}
              >
                <div
                  className={`w-12 h-12 rounded-lg flex items-center justify-center transition-colors ${
                    isActive 
                      ? "bg-white text-[#0f6abf]" 
                      : "bg-gray-100 text-gray-600"
                  }`}
                >
                  <Icon size={22} />
                </div>

                <div className="text-left">
                  <span className="text-base font-semibold text-gray-900 block">
                    {option.title}
                  </span>
                  <span className="text-sm text-gray-500">
                    Join as {option.title.toLowerCase()}
                  </span>
                </div>
              </button>
            );
          })}
        </div>

        {/* Continue Button */}
        <button
          onClick={handleContinue}
          disabled={!selectedOption}
          className={`w-full py-3 rounded-xl font-medium transition-all duration-200 flex items-center justify-center gap-2 ${
            selectedOption
              ? "bg-[#0f6abf] text-white hover:bg-[#0a5ca8]"
              : "bg-gray-200 text-gray-400 cursor-not-allowed"
          }`}
        >
          {selectedOption ? (
            <>
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7" />
              </svg>
              Continue to {options.find(o => o.id === selectedOption)?.title}
            </>
          ) : (
            "Select an option to continue"
          )}
        </button>
      </div>
    </div>
  );
}

export default RegisterOption;